﻿import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SigninComponent } from './signin/signin.component';
import { BlankView } from '../views/blank/blank.view';

const authenticationRoutes: Routes = [
    // login view
    {
        path: 'authentication', component: BlankView,
        children: [
            { path: '', component: SigninComponent },
            { path: 'signin', component: SigninComponent },

            // handle all other routes
            { path: '**', component: SigninComponent }
        ]
    }
];


@NgModule({
    imports: [RouterModule.forChild(authenticationRoutes)],
    exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
